import ApiService from '../../../services/ApiService'
import GeneralService from '../../../services/GeneralService'
import Utils from '../../../Utils/FormatDate'
import NumberAnvisa from '../../../Utils/NumberAnvisa'
import NumberAnvisaField from '../../../components/NumberAnvisaField.vue'
import InstitutionInactive from '../Institutions/components/institutionInactive/institutionInactive.vue'
import ConfirmImportDialog from './components/ConfirmImportDialog.vue'
import CancelImportDialog from './components/CancelImportDialog.vue'

export default {
  components: {
    InstitutionInactive,
    ConfirmImportDialog,
    CancelImportDialog,
    NumberAnvisaField,
  },

  async created() {
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = institution.id
    this.institutionInactive = institution.status == 1
    this.getInstitutions()
    this.getUndiades()
    this.getDepartments()
    this.getCostCenters()
    this.getStandardEquipment()
    this.getManufacturers()
  },

  data: () => ({
    message: '',
    loading: false,
    tableLoading: false,
    showSuccess: false,
    showError: false,
    firstValid: true,
    confirmDialog: false,
    cancelDialog: false,
    cancelLoading: false,
    file: null,
    data: null,
    institutionId: null,
    institutions: [],
    unidadeId: null,
    unidades: [],
    equipmentImport: [],
    equipmentSubmit: [],
    standardEquipmentId: null,
    standardEquipment: [],
    departmentId: null,
    departments: [],
    subDepartments: [],
    costCenters: [],
    manufacturers: [],
    situations: [
      'Aluguel',
      'Comodato',
      'De médico/Equipe',
      'Empréstimo',
      'Próprio',
      'Terceiros',
      'Convênio',
      'Doação',
    ],
    abc: ['A', 'B', 'C'],
    apiService: new ApiService(),
    generalService: new GeneralService(),
    headers: [
      {
        text: 'Nº',
        align: 'center',
        value: 'index',
        width: '10',
        sortable: false,
      },
      {
        text: 'Unidade',
        align: 'center',
        value: 'unidade',
        width: '100',
        sortable: false,
      },
      {
        text: 'E.Padrão',
        align: 'center',
        value: 'institutionStandardEquipmentId',
        width: '100',
        sortable: false,
      },
      {
        text: 'IndexABC',
        align: 'center',
        value: 'indexAbc',
        width: '65',
        sortable: false,
      },
      {
        text: 'Exp.Vida',
        align: 'center',
        value: 'life',
        width: 10,
        sortable: false,
      },
      {
        text: 'Criticidade',
        align: 'center',
        value: 'criticality',
        width: 10,
        sortable: false,
      },
      {
        text: 'Equipamento',
        align: 'center',
        value: 'equipment',
        width: '100',
        sortable: false,
      },
      {
        text: 'Fabricante',
        align: 'center',
        value: 'manufacturer',
        width: '65',
        sortable: false,
      },
      {
        text: 'Modelo',
        align: 'center',
        value: 'model',
        width: '65',
        sortable: false,
      },
      {
        text: 'Setor',
        align: 'center',
        value: 'department',
        width: '80',
        sortable: false,
      },
      {
        text: 'Centro de custo',
        align: 'center',
        value: 'costCenter',
        width: '100',
        sortable: false,
      },
      {
        text: 'Sub Setor',
        align: 'center',
        value: 'subDepartment',
        width: '80',
        sortable: false,
      },
      {
        text: 'Nº Anvisa',
        align: 'center',
        value: 'numberAnvisa',
        width: '210',
        sortable: false,
      },
      {
        text: 'Nº Série',
        align: 'center',
        value: 'serialNumber',
        width: '65',
        sortable: false,
      },
      {
        text: 'Patrimônio',
        align: 'center',
        value: 'propertyCode',
        width: '65',
        sortable: false,
      },
      {
        text: 'Situação',
        align: 'center',
        value: 'situation',
        width: '65',
        sortable: false,
      },
      {
        text: 'Data Compra',
        align: 'center',
        value: 'purchaseDate',
        width: '65',
        sortable: false,
      },
      {
        text: 'Valor Compra',
        align: 'center',
        value: 'purchaseValue',
        width: '65',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    unidadeRules: [(v) => !!v || 'Requerido'],
    standardEquipmentRules: [(v) => !!v || 'Requerido'],
    departmentRules: [(v) => !!v || 'Requerido'],
    situationRules: [(v) => !!v || 'Requerido'],
    nameRules: [
      (v) => !!v || 'Requerido',
      (v) => !v || v.length <= 128 || 'Máximo 128 caracteres',
    ],
    manufacturerRules: [
      (v) => !!v || 'Requerido',
      (v) => !v || v.length <= 128 || 'Máximo 128 caracteres',
    ],
    modelRules: [(v) => !v || v.length <= 64 || 'Máximo 64 caracteres'],
    serialNumberRules: [
      (v) => !!v || 'Requerido',
      (v) => !v || v.length <= 25 || 'Máximo 25 caracteres',
    ],
    propertyCodeRules: [(v) => !v || v.length <= 20 || 'Máximo 20 caracteres'],
  }),

  methods: {
    close() {
      this.$router.go(-1)
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    getItemText(value) {
      return `${value.name} | ${value.institution.initials}`
    },

    saveInventory() {
      const isValid = this.$refs.firstForm.validate()

      const hasAnvisaError = this.equipmentImport.some(
        (item) => !NumberAnvisa.isValid(item.numberAnvisa)
      )

      if (hasAnvisaError) {
        this.$toast.error(
          'O campo "Nº Anvisa" deve ter 11 dígitos ou ser ISENTO nos locais indicados, favor verificar e colocar o número correto'
        )
        return
      }

      if (isValid) {
        this.confirmDialog = true
      } else {
        this.$toast.error(
          'Existem campos não preenchidos ou preenchidos incorretamente'
        )
      }
    },

    cancel() {
      if (this.equipmentImport.length > 0) {
        this.cancelDialog = true
      }
    },

    clearTable() {
      if (this.equipmentImport.length > 0) {
        this.cancelLoading = true
        this.equipmentImport = []
        this.file = null
        this.cancelDialog = false
        this.cancelLoading = false
      }
    },

    clearSubDepartment(item, index) {
      this.equipmentImport.map((equip, arrayIndex) => {
        if (index === arrayIndex) {
          equip.subDepartmentId = null
        }
      })
    },

    getUnidade(value, index) {
      const unidade = this.unidades.find((x) => x.id == value)

      if (unidade) {
        this.equipmentImport.map((equip, arrayIndex) => {
          if (index === arrayIndex) {
            equip.institutionId = unidade.institutionId
            equip.departmentId = null
            equip.subDepartmentId = null
          }
        })
      }
    },

    async importExcelFile() {
      this.equipmentImport = []
      this.tableLoading = true
      var reader = new FileReader()
      reader.readAsDataURL(this.file)
      reader.onload = () => {
        this.data = reader.result
        const fileModel = {
          File: this.data,
          InstitutionId: this.institutionId,
        }

        this.apiService
          .post('equipment/import', fileModel)
          .then((response) => {
            if (response.content.length > 0) {
              response.content.map((equip) => {
                const equipment = {
                  institutionId: equip.institutionId,
                  unidadeId: equip.unidadeId,
                  institutionStandardEquipmentId:
                    equip.institutionStandardEquipmentId,
                  indexAbc: equip.indexAbc,
                  lifeExpectancy: equip.lifeExpectancy,
                  criticality: equip.criticality,
                  equipment: equip.equipment,
                  manufacturer: equip.manufacturer,
                  model: equip.model,
                  departmentId: equip.departmentId,
                  costCenterId: equip.costCenterId,
                  serialNumber: equip.serialNumber,
                  propertyCode: equip.propertyCode,
                  situation: equip.situation,
                  purchaseDate:
                    equip.purchaseDate != null
                      ? this.formatDate(equip.purchaseDate)
                      : null,
                  purchaseValue:
                    equip.purchaseValue != 0 ? equip.purchaseValue : '',
                  numberAnvisa: equip.numberAnvisa,
                  subDepartmentId: equip.subDepartmentId,
                }

                this.equipmentImport.push(equipment)
              })
            }

            this.tableLoading = false
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true
            this.tableLoading = false

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      }
    },

    async submit() {
      this.equipmentSubmit = []
      this.loading = true

      this.equipmentImport.map((equip) => {
        let value = equip.purchaseValue

        const equipment = {
          InstitutionId: equip.institutionId,
          UnidadeId: equip.unidadeId,
          NumberAnvisa: equip.numberAnvisa,
          InstitutionStandardEquipmentId: equip.institutionStandardEquipmentId,
          DepartmentId: equip.departmentId,
          subDepartmentId: equip.subDepartmentId,
          CostCenterId: equip.costCenterId,
          Name: equip.equipment,
          PropertyCode: equip.propertyCode,
          Manufacturer: equip.manufacturer,
          Model: equip.model,
          SerialNumber: equip.serialNumber,
          PurchasePrice: value ? parseFloat(value) : 0,
          PurchaseDate: this.parseDate(equip.purchaseDate),
          EquipmentAcquisitionSituation: this.situations.indexOf(
            equip.situation
          ),
          DegreeImportance: equip.indexAbc,
          Criticality: equip.criticality,
          LifeExpectancy: equip.lifeExpectancy,
        }

        this.equipmentSubmit.push(equipment)
      })

      await this.apiService
        .post('equipment/addRange', this.equipmentSubmit)
        .then((response) => {
          this.loading = false
          this.confirmDialog = false
          this.$toast.success(this.$t('Inventário salvo com sucesso'))
          this.equipmentImport = []
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.confirmDialog = false
      this.loading = false
    },

    async getInventoryFile() {
      var filename = `Inventario_Equipamentos.xlsx`

      this.apiService.get('equipment/fileImport').then((response) => {
        response = `data:application/octet-stream;base64,${response}`
        const link = document.createElement('a')
        link.href = response
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      })
    },

    downloadModel() {
      let link = document.createElement('a')
      link.setAttribute('type', 'hidden')
      link.href =
        'https://equipacarefix.blob.core.windows.net/public/Inventario_Equipamentos (1).xlsx'
      link.download =
        'https://equipacarefix.blob.core.windows.net/public/Inventario_Equipamentos (1).xlsx'
      document.body.appendChild(link)
      link.click()
      link.remove()
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUndiades() {
      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getStandardEquipment() {
      this.standardEquipment =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )
    },

    async getDepartments() {
      await this.apiService
        .get(`department/list/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.subDepartments = response.content
            .map((x) => x.subDepartments)
            .flat()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getCostCenters() {
      await this.apiService
        .get(`costCenter/listActive/${this.institutionId}`)
        .then((response) => {
          this.costCenters = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getManufacturers() {
      await this.apiService
        .get(`manufacturer/list/${this.institutionId}`)
        .then((response) => {
          this.manufacturers = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getCriticality(value, index, indexAbc) {
      await this.apiService
        .get(`standardEquipment/${value}`)
        .then((response) => {
          const newCriticality = this.calculateCriticality(
            response.content,
            indexAbc
          )
          this.equipmentImport.map((equip, arrayIndex) => {
            if (index === arrayIndex) {
              equip.criticality = newCriticality
              equip.lifeExpectancy = response.content.lifeExpectancy
            }
          })
        })
    },

    calculateCriticality(standardEquipment, indexAbc) {
      let functionScore = 0
      let riskScore = 0
      let indexAbcScore = 0

      switch (standardEquipment.functionEquipment) {
        case 1:
          functionScore = 4
          break
        case 2:
          functionScore = 6
          break
        case 3:
          functionScore = 2
          break
        case 4:
          functionScore = 10
          break
        case 5:
          functionScore = 8
          break
        default:
          functionScore = 0
          break
      }

      switch (standardEquipment.equipmentRisk) {
        case 1:
          riskScore = 5
          break
        case 2:
          riskScore = 7
          break
        case 3:
          riskScore = 1
          break
        case 4:
          riskScore = 3
          break
        default:
          riskScore = 0
          break
      }

      switch (indexAbc) {
        case 'A':
          indexAbcScore = 10
          break
        case 'B':
          indexAbcScore = 5
          break
        default:
          indexAbcScore = 0
          break
      }

      return functionScore + riskScore + indexAbcScore
    },

    showSuccessAlert(message) {
      this.message = message

      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
      }, 4000)
    },

    showErrorAlert(message) {
      this.message = message

      this.showError = true

      setTimeout(() => {
        this.showError = false
      }, 4000)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },

  watch: {},
}
